/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["gtx-contents-list-item[_ngcontent-%COMP%]{display:flex;align-items:center;border-bottom:1px solid #e0e0e0;padding:10px}gtx-contents-list-item[_ngcontent-%COMP%]:hover{background-color:#efefef}.node-browser-container[_ngcontent-%COMP%]{cursor:pointer}.schemaName[_ngcontent-%COMP%]{display:flex;width:120px}.schemaName[_ngcontent-%COMP%]   icon[_ngcontent-%COMP%]{margin-right:1px}.no-results[_ngcontent-%COMP%]{font-size:18px;color:#b5b5b9;text-align:center;padding:20px}"];
export { styles as styles };
